import React, {useEffect, useState, useRef} from 'react';
import isIosMobile from 'core/helpers/isIosMobile';
import * as pdfjsLib from 'pdfjs-dist';
import cn from 'classnames';
import Bevis from 'bevis';

import './pdf-viewer.styl';

const block = new Bevis('pdf-viewer');

export default function PdfViewer({url, className}) {
    if (!isIosMobile) {
        return (
            <iframe src={url} className={className} type="application/pdf" title="pdf">
                Здесь должен быть PDF
            </iframe>
        );
    }
    const canvasRef = useRef(null);
    /* Turn on worker for PDF files will be rendered in a separate thread without affecting page performance */
    pdfjsLib.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjsLib.version}/pdf.worker.js`;

    const [pdfRef, setPdfRef] = useState();
    const [currentPage, setCurrentPage] = useState(1);

    const renderPage = (pageNum, pdf = pdfRef) => {
        if (pdf) {
            pdf.getPage(pageNum).then((page) => {
                const viewport = page.getViewport({scale: 1.5});
                const canvas = canvasRef.current;
                canvas.height = viewport.height;
                canvas.width = viewport.width;
                const renderContext = {
                    canvasContext: canvas.getContext('2d'),
                    viewport,
                };
                page.render(renderContext);
            });
        }
    };

    useEffect(() => {
        renderPage(currentPage, pdfRef);
    }, [pdfRef, currentPage, renderPage]);

    useEffect(() => {
        const loadingTask = pdfjsLib.getDocument(url);
        loadingTask.promise.then((loadedPdf) => {
            setPdfRef(loadedPdf);
        }, (reason) => {
            console.error(reason);
        });
    }, [url]);

    const nextPage = () => pdfRef && currentPage < pdfRef.numPages && setCurrentPage(currentPage + 1);

    const prevPage = () => currentPage > 1 && setCurrentPage(currentPage - 1);

    const renderPagination = () => (
        <div className={block.elem('pagination')}>
            <button onClick={prevPage} type="button">&lt;</button>
            <button onClick={nextPage} type="button">&gt;</button>
        </div>
    );

    return (
        <div className={cn(block.name(), className)}>
            <canvas ref={canvasRef} className={block.elem('content')}/>
            {renderPagination()}
        </div>
    );
}
